import { action } from 'easy-peasy';
import { IActionSetReleaseUpdates } from '../types';

const setReleaseUpdates: IActionSetReleaseUpdates = action((state, release) => {
  state.releaseUpdates = release;
});

export default setReleaseUpdates;
